import React from 'react';

import { useMediaQuery } from '@mui/material';
import { commonTheme } from 'portfolio3/styles/theme';
import { Switcher, SwitcherButtonCount } from 'portfolio3/ui-kit';
import { Select } from 'portfolio3/ui-kit/selects';
import { IController } from 'portfolio3/ui-kit/types';

import { IProfileFilterItem } from '../../../../../types';

interface IProfileFilterProps {
  filterValue: number;
  filters: IProfileFilterItem[];
  onFilterChange: (value: number) => void;
}

const ProfileFilter: React.FC<IProfileFilterProps> = ({ filterValue, filters, onFilterChange }) => {
  const isSelectFilter = useMediaQuery(commonTheme.breakpoints.down('commonSm'));

  if (filters.length <= 1) return null;

  if (isSelectFilter) {
    const setFilterController: IController<string | undefined> = {
      handleChange: (code: string | undefined) => {
        onFilterChange(Number(code));
      },
    };

    return (
      <Select
        inputRenderMode="fixed"
        inputSize="small"
        options={filters}
        value={filterValue}
        controller={setFilterController}
      />
    );
  }

  return (
    <Switcher componentSize="medium" value={filterValue} onChange={onFilterChange} useHiddenList>
      {filters.map((filter) => {
        if (filter.count === 0) return;
        return (
          <SwitcherButtonCount key={filter.code} value={filter.code} content={filter.value} count={filter.count} />
        );
      })}
    </Switcher>
  );
};

export default ProfileFilter;
